export const SMARTY_WEBSITE_KEY = '131839944973984763'